interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav aria-label="分页导航" className="flex items-center justify-center gap-2 mt-10">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="w-9 h-9 rounded-md border border-background-200 flex items-center justify-center text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            p === page
              ? "bg-primary-500 text-background-50 font-medium"
              : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="w-9 h-9 rounded-md border border-background-200 flex items-center justify-center text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}